import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Floor, FloorItem, Waiter } from 'src/app/features/reservations/models/Reservation';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { ServersAssignmentService } from '../services/servers-assignment.service';

export interface DialogData {
  serversList: Waiter[],
  restaurantId: number,
  selectedTable: FloorItem,
  selectedFloor: Floor
}

@Component({
  selector: 'app-assign-server',
  templateUrl: './assign-server.component.html'
})
export class AssignServerComponent extends DirtyComponent implements OnInit {
  dataLoading = false;
  searchText?: any;

  serversList: Waiter[] = [];
  selectedIds: number[] = [];
  selectedIdsCopy: number[] = [];

  constructor(
    override dialogRef: MatDialogRef<AssignServerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private service: ServersAssignmentService,
    translate: TranslateService
  ) {
    super(translate)
  }

  ngOnInit(): void {
    this.selectedIds = this.data.selectedTable.tableWaiters.filter(item => item.isSelected).map(item => item.id);
    this.selectedIdsCopy = JSON.parse(JSON.stringify(this.selectedIds));

    this.serversList = JSON.parse(JSON.stringify(this.data.serversList));
    this.serversList.map(item => {
      item.isSelected = this.selectedIds.includes(item.id) || false;
    });
  }

  compare(a1: number[], a2: number[]) {
    return a1.length == a2.length &&
      a1.every(
        (element, index) => element === a2[index]
      );
  }
  override canDeactivate(): boolean {
    return !this.compare(this.selectedIds.sort(), this.selectedIdsCopy.sort());
  };

  hideOption(item: any) {
    return new RegExp(this.searchText, 'i').test(item.name) === false
  }
  isAllHidden() {
    return this.serversList.every(item => this.hideOption(item));
  }

  assignChanged(item: Waiter) {
    this.selectedIds = this.serversList.filter(item => item.isSelected).map(item => item.id);
    if (item.isSelected) {
      item.tabelsCount = item.tabelsCount + 1;
    } else {
      item.tabelsCount = item.tabelsCount - 1;
    }
  }

  saveRecord() {
    this.data.selectedTable.tableWaiters = this.serversList.filter(item => item.isSelected);
    this.dialogRef.close(this.serversList);
  }
}
